import React, { useRef } from 'react';
import { useMovieContext } from '../context/MovieContext';
import './TVShows.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

function TVShows() {
    const { tvShows, handleSelectMovie, error } = useMovieContext();
    const tvShowRef = useRef(null);

    console.log('TV Shows Component:', tvShows);

    if (error) {
        return <div className="error-message">{error}</div>;
    }

    if (!tvShows || tvShows.length === 0) {
        return <div className="loading-message">Loading TV Shows...</div>;
    }

    const scroll = (ref, direction) => {
        if (ref.current) {
            ref.current.scrollBy({ left: direction === 'left' ? -300 : 300, behavior: 'smooth' });
        }
    };

    return (
        <div className='bg'>
        <div className="tvshows-container">
        <div className="tv-show-container">
            <h2 className="tv-show-heading">TV Shows On The Air</h2>
            <button className="scroll-button scroll-left" onClick={() => scroll(tvShowRef, 'left')}>
                <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            <div className="horizontal-scroll-container" ref={tvShowRef}>
                {tvShows && tvShows.map(show => (
                    <div key={show.id} className="tv-show-card" onClick={() => handleSelectMovie(show.id)}>
                        <img className="tv-show-poster" src={`https://image.tmdb.org/t/p/w500/${show.poster_path}`} alt={show.name} />
                    </div>
                ))}
            </div>
            <button className="scroll-button scroll-right" onClick={() => scroll(tvShowRef, 'right')}>
                <FontAwesomeIcon icon={faChevronRight} />
            </button>
        </div>
        <h2 className="title">TV Shows</h2>
        <div className="tv-grid">
            {tvShows.map(show => (
                <div key={show.id} className="tv-card" onClick={() => handleSelectMovie(show.id)}>
                    <img className="movie-poster" src={`https://image.tmdb.org/t/p/w500/${show.poster_path}`} alt={show.name} />
                    <div className="movie-info">
                        <h3>{show.name}</h3>
                        <p>{show.first_air_date}</p>
                    </div>
                </div>
            ))}
        </div>
    </div>
        </div>
    );
}

export default TVShows;
